import { Color, TableCellContent } from '@billy/design-system'
import { CellProps } from 'react-table'

import { InvoicesTableRow } from '../../../types/invoicesTableRow'

export const getInvoicesTableColumnCell = (cellProps: CellProps<InvoicesTableRow>) => {
  const { row, value } = cellProps
  const isVoided = row.original.isVoided

  // The table cell already wraps its content in a paragraph, so this one renders as a block span to stay valid HTML.
  return (
    <TableCellContent as="span" color={isVoided ? Color.Grey300 : undefined} inline={false} title={value} truncate>
      {value}
    </TableCellContent>
  )
}
